import { useQuery } from '@tanstack/react-query';
import { Button } from '@upme/ui/components/button';
import { Checkbox } from '@upme/ui/components/checkbox';
import { Input } from '@upme/ui/components/input';
import { useState } from 'react';
import { useCreatePhrase, useDeletePhrase, useUpdateCityConfig, useUpdatePhrase } from '../mutations';
import { morningCityConfigOptions, morningPhrasesOptions } from '../queries';
import { CityScopeSelect } from './city-scope-select';

export function MorningPhrasesTab({ kind }: { kind: 'GREETING' | 'CTA' }) {
  const [scope, setScope] = useState('global');
  const cityId = scope === 'global' ? null : scope;
  const { data: phrases = [] } = useQuery(morningPhrasesOptions(kind, scope));
  const create = useCreatePhrase();
  const update = useUpdatePhrase();
  const del = useDeletePhrase();
  const [text, setText] = useState('');

  return (
    <div className="space-y-4 p-4">
      <CityScopeSelect value={scope} onChange={setScope} />
      {cityId && <CityPoolToggle cityId={cityId} kind={kind} />}
      <div className="flex gap-2">
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={kind === 'GREETING' ? 'Бонжур' : 'Включайся и проявляйся 🔥'}
        />
        <Button
          disabled={!text.trim()}
          onClick={() => {
            create.mutate({ kind, text: text.trim(), cityId });
            setText('');
          }}
        >
          Добавить
        </Button>
      </div>
      <ul className="space-y-2">
        {phrases.map((p) => (
          <li key={p.id} className="flex items-center gap-3 rounded border p-2">
            <Checkbox
              checked={p.isActive}
              onCheckedChange={(v) => update.mutate({ id: p.id, body: { isActive: Boolean(v) } })}
            />
            <span className="flex-1">{p.text}</span>
            <span className="text-xs text-muted-foreground">{p.cityId ? 'город' : 'общее'}</span>
            <Button variant="ghost" size="sm" onClick={() => del.mutate(p.id)}>
              Удалить
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}

function CityPoolToggle({ cityId, kind }: { cityId: string; kind: 'GREETING' | 'CTA' }) {
  const { data } = useQuery(morningCityConfigOptions(cityId));
  const update = useUpdateCityConfig(cityId);
  if (!data) return null;
  const checked = kind === 'GREETING' ? data.useGlobalGreetings : data.useGlobalCtas;
  return (
    <div className="flex items-center gap-2 text-sm">
      <Checkbox
        checked={checked}
        onCheckedChange={(v) =>
          update.mutate(
            kind === 'GREETING' ? { useGlobalGreetings: Boolean(v) } : { useGlobalCtas: Boolean(v) },
          )
        }
      />
      <span>Использовать глобальный пул вместе с городскими</span>
    </div>
  );
}
